// @ts-nocheck
import { CHANGE_REQUEST_COMMENTS_ADD_ERROR, CHANGE_REQUEST_COMMENTS_ADD_LOADING, CHANGE_REQUEST_COMMENTS_ADD_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const change_request_comments_add = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: CHANGE_REQUEST_COMMENTS_ADD_LOADING,
                data: true
            })
            Authservices.change_request_comments_add(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: CHANGE_REQUEST_COMMENTS_ADD_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: CHANGE_REQUEST_COMMENTS_ADD_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}